import React, { useState, useEffect } from "react";
import ChatBot from "../ChatBot";
import "./chatBotButton.css";

export default function ChatBotButton() {
  const [open, setOpen] = useState(false);
  const [showNotification, setShowNotification] = useState(true);

  // Si abre el chat, quitamos la notificación
  useEffect(() => {
    if (open) {
      setShowNotification(false);
    }
  }, [open]);

  return (
    <>
      <div className={`chatbot-button-wrapper ${open ? "open" : ""}`}>
        <button
          className="chatbot-button"
          onClick={() => setOpen(!open)}
        >
          💬
        </button>

        {showNotification && (
          <span className="chatbot-notification">1</span>
        )}

        {/* 👇 Leyenda (solo cuando está cerrado) */}
        {!open && (
          <div className="chatbot-label">
            Asistente virtual
          </div>
        )}
      </div>

      {/* 👇 ChatBot renderizado */}
      {open && <ChatBot onClose={() => setOpen(false)} />}
    </>
  );
}
